import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

/* Layout */
import Layout from '@/layout'

/* Router Modules */
import componentsRouter from './modules/components'
import chartsRouter from './modules/charts'
import tableRouter from './modules/table'
import nestedRouter from './modules/nested'

/**
 * Note: sub-menu only appear when route children.length >= 1
 * Detail see: https://panjiachen.github.io/vue-element-admin-site/guide/essentials/router-and-nav.html
 *
 * hidden: true                   if set true, item will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu
 *                                if not set alwaysShow, when item has more than one children route,
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noRedirect           if set noRedirect will no redirect in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
    roles: ['admin','editor']    control the page roles (you can set multiple roles)
    title: 'title'               the name show in sidebar and breadcrumb (recommend set)
    icon: 'svg-name'/'el-icon-x' the icon show in the sidebar
    noCache: true                if set true, the page will no be cached(default is false)
    affix: true                  if set true, the tag will affix in the tags-view
    breadcrumb: false            if set false, the item will hidden in breadcrumb(default is true)
    activeMenu: '/example/list'  if set path, the sidebar will highlight the path you set
  }
 */

/**
 * constantRoutes
 * a base page that does not have permission requirements
 * all roles can be accessed
 */
export const constantRoutes = [
  {
    path: '/',
    component: Layout,
    redirect: '/dashboard',
    children: [
      {
        path: 'dashboard',
        component: () => import('@/views/dashboard/index'),
        name: 'Dashboard',
        meta: { title: '首页', icon: 'dashboard', affix: true }
      }
    ]
  },
  {
    path: '/navigator',
    component: Layout,
    hidden: true,
    redirect: 'noRedirect',
    children: [
      {
        path: 'to-dashboard',
        component: () => import('@/views/navigator/to-dashboard'),
        name: 'ToDashboard',
        meta: { title: '导航', roles: ['admin', 'adminCross', 'editor'] }
      }
    ]
  },
  {
    path: '/redirect',
    component: Layout,
    hidden: true,
    children: [
      {
        path: '/redirect/:path(.*)',
        component: () => import('@/views/redirect/index')
      }
    ]
  },
  {
    path: '/login',
    component: () => import('@/views/login/index'),
    hidden: true
  },
  {
    path: '/auth-redirect',
    component: () => import('@/views/login/auth-redirect'),
    hidden: true
  },

  // 锁屏
  {
    path: '/lock',
    hidden: true,
    name: '锁屏页',
    component: () => import('@/views/common/lock')
  },
  {
    path: '/404',
    component: () => import('@/views/error-page/404'),
    hidden: true
  },
  {
    path: '/401',
    component: () => import('@/views/error-page/401'),
    hidden: true
  }
]

/**
 * asyncRoutes
 * the routes that need to be dynamically loaded based on user roles
 * 这份异步路由又使用了
 */
// export const asyncRoutes = [
//   {
//     path: '/merchant',
//     component: Layout,
//     redirect: 'noRedirect',
//     alwaysShow: true, // will always show the root menu
//     meta: {
//       id: '3469',
//       title: '商家管理',
//       roles: ['admin']
//     },
//     children: [
//       {
//         path: 'merchantlist',
//         component: () => import('@/views/merchant/merchantlist'),
//         name: 'MerchantList',
//         meta: { title: '商家列表', id: '3470', roles: ['admin'] }
//       },
//       {
//         path: 'depositList',
//         component: () => import('@/views/other/depositList'),
//         name: 'DepositList',
//         meta: { title: '储值卡', id: '3471', roles: ['admin'] }
//       },
//       {
//         path: 'couponList',
//         component: () => import('@/views/other/couponList'),
//         name: 'CouponList',
//         meta: { title: '代金券', id: '3472', roles: ['admin'] }
//       }
//       // {
//       //   path: 'summarylist',
//       //   component: () => import('@/views/merchant/summarylist'),
//       //   name: 'SummaryList',
//       //   meta: { title: '商家首页', id: '3479', roles: ['adminCross'] }
//       // }
//     ]
//   },
//   {
//     path: '/merchantindex',
//     component: Layout,
//     meta: { title: '商家首页', id: '4479', roles: ['adminCross', 'editor'] },
//     children: [
//       {
//         path: 'summarylist',
//         component: () => import('@/views/merchant/summarylist'),
//         name: 'SummaryList',
//         meta: { title: '商家首页', id: '4480', roles: ['adminCross', 'editor'] }
//       }
//     ]
//   },
//   {
//     path: '/basic',
//     component: Layout,
//     redirect: 'noRedirect',
//     alwaysShow: true,
//     meta: {
//       id: '6000',
//       title: '基础设置',
//       roles: ['adminCross', 'admin', 'editor']
//     },
//     children: [
//       {
//         path: 'distributionPoint',
//         component: () => import('@/views/basic/distributionPoint'),
//         name: 'DistributionPoint',
//         meta: { title: '配送点位', id: '6001', roles: ['adminCross', 'editor'] }
//       },
//       {
//         path: 'promotionPoint',
//         component: () => import('@/views/basic/promotionPoint'),
//         name: 'PromotionPoint',
//         meta: { title: '推广点位', id: '6002', roles: ['adminCross', 'editor'] }
//       },
//       {
//         path: 'swiperManage',
//         component: () => import('@/views/basic/swiperManage'),
//         name: 'SwiperManage',
//         meta: { title: '广告轮播', id: '6003', roles: ['admin', 'adminCross', 'editor'] }
//       },
//       {
//         path: 'infoEdit',
//         component: () => import('@/views/basic/infoEdit'),
//         name: 'InfoEdit',
//         meta: { title: '商家信息', id: '6004', roles: ['adminCross', 'editor'] }
//       },
//       {
//         path: 'dinnerTableList',
//         component: () => import('@/views/basic/dinnerTableList'),
//         name: 'DinnerTableList',
//         meta: { title: '餐桌列表', id: '6005', roles: ['adminCross', 'editor'] }
//       },
//       {
//         path: 'configInfo',
//         component: () => import('@/views/other/configInfo'),
//         name: 'ConfigInfo',
//         meta: { title: '程序配置', id: '3472', roles: ['admin'] }
//       }
//     ]
//   },

// ]

const createRouter = () => new Router({
  // mode: 'history', // require service support
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})

const router = createRouter()

// Detail see: https://github.com/vuejs/vue-router/issues/1234#issuecomment-357941465
export function resetRouter() {
  const newRouter = createRouter()
  router.matcher = newRouter.matcher // reset router
}

export default router
